<template>
  <div class="wrapper" :style="{'z-index': z_index?z_index:2500}">
    <div class="title" v-if="!noBack">
      <span>{{title}}</span>
      <span class="back" @click="back"> <i class="iconfont el-icon-back"></i> 返回 </span>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
  export default {
    props: {
      title: '',
      noBack: {
        type: Boolean,
        default: false
      },
      selfHandle: {
        type: Boolean,
        default: false
      },
      z_index:{
        type:[String,Number],
        default:''
      }
    },
    data() {
      return {
      };
    },
    methods: {

      back() {
        if (this.selfHandle) {
          this.$emit('back')
        } else {
          this.$router.back();
        }
      }

    }
  }
</script>

<style lang="scss" scoped>

  .wrapper {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    //z-index: 2500;
    background: #fff;
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    .title {
      height: 59px;
      line-height: 59px;
      font-size: 16px;
      font-weight: 500;
      text-indent: 40px;

      .back {
        float: right;
        margin-right: 40px;
        cursor: pointer;
      }
    }
  }
</style>
